import { render, staticRenderFns } from "./disinfectCheck.vue?vue&type=template&id=572c65a8&scoped=true&"
import script from "./disinfectCheck.vue?vue&type=script&lang=ts&"
export * from "./disinfectCheck.vue?vue&type=script&lang=ts&"
import style0 from "./disinfectCheck.vue?vue&type=style&index=0&id=572c65a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c65a8",
  null
  
)

export default component.exports